import { Component, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { Content, AlertController, Platform, PopoverController } from 'ionic-angular';
import { TeaserDataModel, TeaserModel, TeaserPostModel, TeaserResponseModel, DefinoInputRentenTool } from './teaser.model';

import { PopoverInfo } from './teaser.popover';
import { AbstractWS } from './teaser.service';
import { RestWS } from '../../app/services/restService';
import { ICTPartnerData } from '../../models/bundle';

@Component({ selector: 'teaser', templateUrl: 'teaser.html' })
export class TeaserComponent {

	@ViewChild(Content) content: Content;
	@ViewChild("infoBoxContainer") infoBoxContainer;
	@ViewChild("footer") footer;

	@Input() initialDefinoData: DefinoInputRentenTool = null;;

	private tModel: TeaserModel[];
	private tModelBK: TeaserModel[];
	private postModel: TeaserPostModel;
	private results: TeaserResponseModel;
	private callToService: any = undefined;
	private gewuenschteRenteIsModified: boolean = false;
	private minHeight: number = 30;
	private barValuesL: number[] = null;
	private barValuesR: number[] = null;
	private retirementDefValues: number[];
	private firstCall: boolean;
	private showFirstBox: boolean;
	private showSecondBox: boolean;
	private salesOrg: ICTPartnerData;
	private currentWidth: any;
	public boxFixed: boolean = false;
	public boxAbsolute: boolean = false;
	public boxWidth: string;
	public animateVal: boolean = false;
	public viewReady: boolean = false;
	public loadCalculations: boolean = false;
	public showBoxResult: boolean = false;
	public box1: boolean;
	public isEmptyField: TeaserModel[];

	constructor(
		private service: AbstractWS,
		private changeDetectorRef: ChangeDetectorRef,
		private alertCtrl: AlertController,
		private platform: Platform,
		private popoverCtrl: PopoverController,
		private rest: RestWS) {

		this.platform.ready().then(() => {
			this.getInternetExplorerVersion();
			this.viewReady = true;
			this.currentWidth = platform.width();
			this.initData();
		});
	}

	initData() {
		let teaser = new TeaserDataModel();
		this.tModel = teaser.opt;
		this.tModelBK = this.copyObject(teaser.opt);
		this.retirementDefValues = [67, 63, 67, 1];
		this.postModel = new TeaserPostModel(0, '0', 0, 0, 50, 60, 70, 0, 0, 0, 0, 0, 0, 0, 0, 0, 90);
		this.firstCall = true;
		this.setSelectValues(true);
		this.valuesChanged(null, false);
		this.hasMandatoryEmptyField();
		this.rest.getSalesOrg().then((salesOrg: ICTPartnerData) => {
			this.salesOrg = salesOrg ? salesOrg : null;
		})
	}

	hasMandatoryEmptyField() {
		this.isEmptyField = this.tModel.filter(el => el.mandatory == true && el.value == 0);
	}

	valuesChanged(item: TeaserModel, agesChanged: boolean) {
		this.hasMandatoryEmptyField();
		this.animateVal = false;
		this.loadCalculations = true;
		if (item && (item.id == 'alter' || item.id == 'profilAlterRuzp')) {
			this.setSelectValues(agesChanged);
			if (item.id == 'alter') {
				let itemProfil = this.tModel.filter(el => el.id == 'profilAlterRuzp')[0];
				let valuesProfil = this.getAgeValues(itemProfil);
				if (valuesProfil.length > 0) {
					itemProfil.values[0] = valuesProfil[valuesProfil.length - 1].value;
					itemProfil.values[1] = valuesProfil[0].value;
					itemProfil.values[2] = valuesProfil[valuesProfil.length - 1].value;
				}
			}
		} else if (item && item.id == 'endeSpar') {
			this.tModel.filter(el => el.id == 'beginnSpar')[0].values[2] = item.value;
			if (this.tModel.filter(el => el.id == 'beginnSpar')[0].value > item.value) {
				this.tModel.filter(el => el.id == 'beginnSpar')[0].value = item.value;
				this.tModel.filter(el => el.id == 'beginnSpar')[0].values[0] = item.value;
			}
		}

		this.gewuenschteRenteIsModified = item && item.id == 'einkommenNekG' ? false : true;
		let tModelLocal = this.copyObject(this.tModel);
		tModelLocal.forEach(element => {
			if (element.symbol == 'percent') {
				element.value = element.value / 100;
			}
			this.postModel[element.id] = element.value;
		});
		if (this.firstCall && this.showSecondBox) {
			this.postModel.steigerungGes = this.postModel.steigerungGes / 10;
			this.postModel.inflation = this.postModel.inflation / 10;
			this.firstCall = false;
		}
		if (!this.showSecondBox) {
			this.postModel.steigerungGes = 0;
			this.postModel.inflation = 0;
		}
		this.postModel.personAnrede = this.postModel.personAnrede + '';
		if (this.callToService) {
			clearTimeout(this.callToService);
		}
		this.callToService = setTimeout(() => {
			if (this.initialDefinoData) {
				this.service.getMapInputAndDefinoInput(this.postModel, this.initialDefinoData).then((data) => {
					this.initialDefinoData = null;
					this.postModel = data;
					this.initValuesFromDefino();
					this.doCalculations(item);
				}).catch(() => {
					this.doCalculations(item);
				});
			} else {
				this.doCalculations(item);
			}
		}, 1000);

	}

	private prepareData(item: TeaserModel) {
		if (item && item.id == 'einkommenNekG' && !this.gewuenschteRenteIsModified) {
			this.tModel.filter(el => el.id == 'gewuenschteRente')[0].value = Math.round(this.results.definoBedarf * 100) / 100;
			this.tModel.filter(el => el.id == 'gewuenschteRente')[0].values[0] = Math.round(this.results.definoBedarf * 100) / 100;
			this.gewuenschteRenteIsModified = false;
		}
		this.showBoxResult = this.tModel.filter(el => el.id == 'profilGvsAltersrenteMtl')[0].value > 0 || this.tModel.filter(el => el.id == 'einkommenNekG')[0].value > 0;
		this.animateVal = true;
		this.loadCalculations = false;
		this.barValuesL = [];
		this.barValuesR = [];
		this.getPercentBarsBrutto();
		this.getPercentBarsNetto();
		this.changeDetectorRef.detectChanges();
	}

	private initValuesFromDefino() {
		this.tModel.forEach(element => {
			if (element.id == "alter") {
				element.values[0] = this.postModel.alter;
			} else if (element.id == "personAnrede") {
				element.value = Number(this.postModel.personAnrede);
			} else if (element.id == "profilAlterRuzp") {
				element.values[0] = this.postModel.profilAlterRuzp;
			} else if (element.id == "profilGvsAltersrenteMtl") {
				element.values[0] = this.postModel.profilGvsAltersrenteMtl;
				element.value = this.postModel.profilGvsAltersrenteMtl;
			} else if (element.id == "einkommenNekG") {
				element.values[0] = this.postModel.einkommenNekG;
				element.value = this.postModel.einkommenNekG;
			} else if (element.id == "gewuenschteRente") {
				element.values[0] = this.postModel.gewuenschteRente;
			} else if (element.id == "inflation") {
				element.values[0] = this.postModel.inflation * 1000;
				this.showSecondBox = this.postModel.inflation && this.postModel.inflation > 0 ? true :this.showSecondBox;
			} else if (element.id == "steigerungGes") {
				element.values[0] = this.postModel.steigerungGes * 1000;
			} else if (element.id == "sparrate") {
				element.values[0] = this.postModel.sparrate;
			} else if (element.id == "sonstigeRente") {
				element.values[0] = this.postModel.sonstigeRente;
				element.value = this.postModel.sonstigeRente;
				this.showFirstBox = this.postModel.sonstigeRente && this.postModel.sonstigeRente > 0;
				// this.showBox2
			} else if (element.id == "beginnSpar") {
				element.values[0] = this.postModel.beginnSpar;
			} else if (element.id == "endeSpar") {
				element.values[0] = this.postModel.endeSpar;
			} else if (element.id == "steigerungSpar") {
				element.values[0] = this.postModel.steigerungSpar;
			} else if (element.id == "kapital") {
				element.values[0] = this.postModel.kapital;
				this.showSecondBox = this.postModel.kapital && this.postModel.kapital > 0 ? true : this.showSecondBox;
			} else if (element.id == "steigerungKapt") {
				element.values[0] = this.postModel.steigerungKapt;
			}
		});
	}

	private doCalculations(item: TeaserModel) {
		this.service.getCalculations(this.postModel).then((response: TeaserResponseModel) => {
			this.results = response;
			this.prepareData(item);
		}).catch((error) => {
			this.loadCalculations = false;
			this.animateVal = true;
		});
	}

	getAgeValues(item: TeaserModel) {
		let values = [];
		let valueAlter = this.tModel.filter(el => el.id == 'alter')[0].value;
		let birthYear = new Date().getFullYear() - valueAlter;
		let reduceVal = 0;
		if (birthYear < 1958) {
			reduceVal = 2;
		}
		else if (birthYear < 1964) {
			reduceVal = 1;
		}
		for (let i = this.retirementDefValues[1]; i < this.retirementDefValues[2] + 1 - reduceVal; i++) {
			if (valueAlter <= i) {
				values.push({ value: i });
			} else {
				item.values[1] = valueAlter;
			}
		}
		return values;
	}

	setSelectValues(agesChanged) {
		let years = this.tModel.filter(el => el.id == 'profilAlterRuzp')[0].value;
		let totalYears = years - this.tModel.filter(el => el.id == 'alter')[0].value;
		let yearsValues1 = [];
		let yearsValues2 = [];
		let initYear = new Date().getFullYear() - this.tModel.filter(el => el.id == 'alter')[0].value;
		let maxYear = new Date().getFullYear() - initYear + totalYears;

		yearsValues1.push(this.tModel.filter(el => el.id == 'beginnSpar')[0].values[0]);

		for (let i = 0; i < maxYear; i++) {
			if ((i == 0) || (i == maxYear - 1)) {
				yearsValues1.push(initYear + i);
			}
		}

		this.tModel.filter(el => el.id == 'beginnSpar')[0].values = yearsValues1;
		this.tModel.filter(el => el.id == 'beginnSpar')[0].value = yearsValues1[0];

		if (agesChanged) {
			yearsValues2.push(this.tModel.filter(el => el.id == 'beginnSpar')[0].values[2] + 1);
		} else {
			yearsValues2.push(this.tModel.filter(el => el.id == 'endeSpar')[0].values[0]);
		}

		for (let i = 0; i <= maxYear; i++) {
			if ((i == 0) || (i == maxYear)) {
				yearsValues2.push(yearsValues1[1] + i);
			}
		}

		this.tModel.filter(el => el.id == 'endeSpar')[0].values = yearsValues2;
		this.tModel.filter(el => el.id == 'endeSpar')[0].value = yearsValues2[yearsValues2.length - 1];
	}

	openPdf() {
		this.service.getPDFFile(this.postModel, this.results);

	}

	openContact() {
		window.open(this.salesOrg.company.extendedFieldC);
	}

	// utils
	scrollHandler(event) {
		if (this.currentWidth >= 1092) {
			this.boxWidth = (this.infoBoxContainer.nativeElement.offsetWidth - 20) + 'px';
			// this.boxFixed = (event.scrollTop > this.infoBoxContainer.nativeElement.offsetTop + 30) && ((event.scrollTop + 720) < event.scrollElement.scrollHeight) && this.showFirstBox && this.showSecondBox;
			this.boxFixed = (event.scrollTop > this.infoBoxContainer.nativeElement.offsetTop + 30) && (this.showFirstBox || this.showSecondBox);
			this.boxAbsolute = (event.scrollTop + 700 >= this.footer.nativeElement.offsetTop) && (this.showFirstBox || this.showSecondBox);
			this.content.resize();
			//console.log(event.scrollTop + " | " + this.footer.nativeElement.offsetTop);
			this.changeDetectorRef.detectChanges();
		}
	}

	getDisplayNumber(num) {
		let userLang = window.navigator.language;
		num = Math.round(num);
		return Intl.NumberFormat(userLang).format(num);
	}

	formatCurrency(number, digi?) {
		let d = digi ? digi : 2;
		let options: any = {
			minimumFractionDigits: d,
			maximumFractionDigits: d
		};
		var userLang = window.navigator.language;
		return Intl.NumberFormat(userLang, options).format(number);
	}

	getDisplayAge(num) {
		return Math.round(num);
	}

	getInternetExplorerVersion() {
		let ua = window.navigator.userAgent;
		let msie = ua.indexOf("MSIE ");

		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
			let rv = -1;
			if (navigator.appName == 'Microsoft Internet Explorer') {
				let ua = navigator.userAgent;
				let re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
				if (re.exec(ua) != null)
					rv = parseFloat(RegExp.$1);
			} else if (navigator.appName == 'Netscape') {
				let ua = navigator.userAgent;
				let re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
				if (re.exec(ua) != null)
					rv = parseFloat(RegExp.$1);
			}
			if (rv < 11) {
				let alert = this.alertCtrl.create({
					title: 'Incompatible browser.',
					subTitle: 'Your browser is too old. Please, for your own security, update your browser to the last version.',
					buttons: ['Dismiss']
				});
				alert.present();
			}
			return false;
		} else {
			return true;
		}
	}

	copyObject(object: any) {
		return JSON.parse(JSON.stringify(object));
	}

	getPercent(value) {
		return value > 100 ? 100 : value;
	}

	setSonstigeRente(box: boolean): boolean {
		this.setSelectValues(false);

		let item = null;
		if (box) {
			item = this.tModel.filter(el => el.id == 'sonstigeRente')[0];
		} else {
			item = this.tModel.filter(el => el.id == 'sparrate')[0];
		}

		item.value = 0;
		item.values[0] = 0;

		return box;
	}

	openInfo(myEvent, data) {
		let popover = this.popoverCtrl.create(PopoverInfo, { infoData: data });
		popover.present({
			ev: myEvent
		});
	}

	getPercentBarsBrutto() {
		let maxSizeL = 140;
		let countZeroValues = 0, countNoZeroValues = 0, pixelsToDecrease = 0;
		this.barValuesL.push(this.getPercent((this.results.bruttotluecke * 100) / (this.results.bruttobedarf)) * maxSizeL / 100);
		this.barValuesL.push(this.getPercent((this.results.bruttoPrivKapt * 100) / (this.results.bruttobedarf)) * maxSizeL / 100);
		this.barValuesL.push(this.getPercent((this.results.bruttoGes * 100) / (this.results.bruttobedarf)) * maxSizeL / 100);

		for (var i = 0; i < this.barValuesL.length; i++) {
			if (this.barValuesL[i] == 0) {
				this.barValuesL[i] = 0;
				countZeroValues++;
			}
		}
		if (countZeroValues > 0) {
			this.minHeight = countZeroValues * 30;
			countNoZeroValues = this.barValuesL.length - countZeroValues;
			pixelsToDecrease = this.minHeight / countNoZeroValues;

			for (var j = 0; j < this.barValuesL.length; j++) {
				if (this.barValuesL[j] > 30) {
					this.barValuesL[j] -= pixelsToDecrease;
				}
			}
		}
	}

	getPercentBarsNetto() {
		let countZeroValues = 0, countNoZeroValues = 0, pixelsToDecrease = 0;

		let maxSizeR = (this.results.bedarf * 100 / this.results.bruttobedarf) * 140 / 100;

		this.barValuesR.push(this.getPercent((this.results.luecke * 100) / (this.results.bedarf)) * maxSizeR / 100);
		this.barValuesR.push(this.getPercent(((this.results.nettoPriv + this.results.nettoKapt) * 100) / (this.results.bedarf)) * maxSizeR / 100);
		this.barValuesR.push(this.getPercent((this.results.nettoGes * 100) / (this.results.bedarf)) * maxSizeR / 100);

		for (var i = 0; i < this.barValuesR.length; i++) {
			if (this.barValuesR[i] == 0) {
				this.barValuesR[i] = 0;
				countZeroValues++;
			}
		}
		if (countZeroValues > 0) {
			this.minHeight = countZeroValues * 30;
			countNoZeroValues = this.barValuesR.length - countZeroValues;
			pixelsToDecrease = this.minHeight / countNoZeroValues;

			for (var j = 0; j < this.barValuesR.length; j++) {
				if (this.barValuesR[j] > 30) {
					this.barValuesR[j] -= pixelsToDecrease;
				}
			}
		}
	}

	showBox1() {
		this.showFirstBox = !this.showFirstBox;
		if (!this.showFirstBox) {
			let box1Elements = this.tModelBK.filter((item) => {
				return item.allocated == 'box2';
			});
			for (let i = 0; i < box1Elements.length; i++) {
				for (let j = 0; j < this.tModel.length; j++) {
					if (this.tModel[j].id == box1Elements[i].id) {
						this.tModel[j].value = box1Elements[i].value;
						this.tModel[j].values = box1Elements[i].values;
					}
				}
			}
		}
		this.valuesChanged(null, false);
	}

	showBox2() {
		this.showSecondBox = !this.showSecondBox;
		if (!this.showSecondBox) {
			let box2Elements = this.tModelBK.filter((item) => {
				return item.allocated == 'box3';
			});
			for (let i = 0; i < box2Elements.length; i++) {
				for (let j = 0; j < this.tModel.length; j++) {
					if (this.tModel[j].id == box2Elements[i].id) {
						this.tModel[j].value = box2Elements[i].value / 10;
						this.tModel[j].values = box2Elements[i].values;
					}
				}
			}
		}
		this.valuesChanged(null, false);
	}
}



// WEBPACK FOOTER //
// ./src/components/teaser/teaser.ts